import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  fetchParticipantsRequests,
  fetchParticipantsRequestsCompleted,
} from "../../slices/participants-requests";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleFetchParticipantsRequests({ page, items }) {
  return await workflowsService.listCurrentParticipantsRequest(page, items);
}

async function handleGetUsers({ tokens, page, items, filters }) {
  return await workflowsService.listUsers(tokens, page, items, filters);
}

function* listParticipantsRequestsSaga({ payload }) {
  try {
    yield put(fetchParticipantsRequests());
    const participantsRequestsData = yield call(
      handleFetchParticipantsRequests,
      payload
    );
    const usersTokens = participantsRequestsData.data.map(
      (item) => item.user_token
    );
    const { data: usersData } = yield call(handleGetUsers, {
      tokens: usersTokens,
      page: 1,
      items: 10,
      filters: {},
    });

    participantsRequestsData.data = participantsRequestsData.data.map(
      (item) => {
        const user = usersData.find((user) => user.token === item.user_token);
        return {
          ...item,
          fullName: `${user.name} ${user.last_name}`,
        };
      }
    );
    yield put(fetchParticipantsRequestsCompleted(participantsRequestsData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* listParticipantsRequestsWatcherSaga() {
  yield takeLatest(
    sagaActions.START_FETCH_LIST_PARTICIPANTS_REQUESTS,
    listParticipantsRequestsSaga
  );
}
